if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        const premiumThumbRail = this.elements.thumbnails.closest('.product-thumbnails--overlay, .product-thumbnails--strip');
        if (!premiumThumbRail) {
          this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
            mediaToSwitch
              .querySelector('button')
              .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
          });
        }
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const premiumPagedMobile =
          this.elements.viewer.querySelector('.pdp-image-grid--paged') &&
          window.matchMedia('(max-width: 989px)').matches;
        if (premiumPagedMobile) return;

        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]:not([data-skipp-clone])`
        ) || this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }

        const list = activeMedia.closest('ul');
        const premiumPaged =
          list && list.classList.contains('pdp-image-grid--paged');
        const premiumPagedMobile =
          premiumPaged && window.matchMedia('(max-width: 989px)').matches;
        const premiumPagedDesktop =
          premiumPaged && window.matchMedia('(min-width: 990px)').matches;

        if (premiumPagedMobile && list && typeof list._skippGoToMedia === 'function' && !prepend) {
          this.preventStickyHeader();
          list._skippGoToMedia(mediaId, false);
          return;
        }

        if (!premiumPagedMobile) {
          this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
            element.classList.remove('is-active');
          });
          activeMedia?.classList?.add('is-active');
        } else if (list) {
          const slides = Array.from(list.querySelectorAll('li.product__media-item'));
          const idx = Math.max(0, slides.indexOf(activeMedia));
          slides.forEach((slide, i) => {
            slide.classList.toggle('is-active', i === idx);
          });
        }

        if (prepend && !premiumPaged) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();

        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails || premiumPagedDesktop || premiumPagedMobile) {
            if (premiumPagedMobile && list) {
              const slides = Array.from(list.querySelectorAll('li.product__media-item'));
              const idx = Math.max(0, slides.indexOf(activeMedia));
              slides.forEach(function (slide, i) {
                slide.classList.toggle('is-active', i === idx);
                slide.classList.remove('is-skipp-mobile-peek');
                slide.classList.toggle('is-skipp-mobile-active', i === idx);
              });
              list.classList.toggle('skipp-mweb-no-peek', slides.length < 2 || idx >= slides.length - 1);
              list.dataset.skippMobileSlideIndex = String(idx);
              list.style.transform = '';
              list.style.transition = '';
              if (typeof list._skippMarkProgrammaticScroll === 'function') {
                list._skippMarkProgrammaticScroll(220);
              } else {
                list.dataset.skippProgrammaticScroll = '1';
                window.setTimeout(function () {
                  delete list.dataset.skippProgrammaticScroll;
                }, 220);
              }
              list.scrollTo({ left: activeMedia.offsetLeft, behavior: 'auto' });
              this.elements.viewer.resetPages();
            } else {
              const scrollHost = premiumPagedDesktop ? list.closest('slider-component') : activeMedia.parentElement;
              let targetLeft = activeMedia.offsetLeft;
              if (premiumPagedDesktop && scrollHost) {
                const pageWidth = scrollHost.clientWidth;
                const slides = Array.from(
                  list.querySelectorAll('li.product__media-item:not(.skipp-pdp-gallery-video)')
                );
                const idx = slides.indexOf(activeMedia);
                const perPage = parseInt(getComputedStyle(list).getPropertyValue('--skipp-pdp-items-per-page'), 10) || 2;
                const page = idx >= 0 ? Math.floor(idx / perPage) : 0;
                targetLeft = page * pageWidth;
              }
              scrollHost?.scrollTo({ left: targetLeft, behavior: 'auto' });
            }
          }
          if (premiumPagedMobile) return;
          const activeMediaRect = activeMedia.getBoundingClientRect();
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });

        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail =
          this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]:not([data-skipp-clone])`) ||
          this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        if (activeThumbnail && !premiumPagedMobile) {
          this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        const mediaId = thumbnail.dataset.target;
        this.elements.thumbnails
          .querySelectorAll('button.thumbnail')
          .forEach((element) => element.removeAttribute('aria-current'));
        this.elements.thumbnails
          .querySelectorAll(`[data-target="${mediaId}"] button.thumbnail`)
          .forEach((button) => button.setAttribute('aria-current', 'true'));

        if (this.elements.thumbnails.closest('.product-thumbnails--overlay, .product-thumbnails--strip')) {
          const thumbList =
            this.elements.thumbnails.querySelector('.skipp-pdp-thumb-strip') ||
            this.elements.thumbnails.querySelector('.skipp-pdp-thumb-carousel');
          if (thumbList && typeof thumbList._skippCenterForMedia === 'function') {
            thumbList._skippCenterForMedia(mediaId);
          }
          return;
        }

        const canonical =
          this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]:not([data-skipp-clone])`) ||
          thumbnail;
        if (this.elements.thumbnails.isSlideVisible(canonical, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: canonical.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        const announce = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        if (image.complete && image.naturalWidth > 0) {
          announce();
          return;
        }
        image.onload = () => {
          announce();
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (!deferredMedia) return;

        const list = activeItem.closest('ul');
        const premiumMwebInlineVideo =
          list &&
          list.classList.contains('pdp-image-grid--paged') &&
          window.matchMedia('(max-width: 989px)').matches &&
          activeItem.classList.contains('skipp-pdp-gallery-video');

        deferredMedia.loadContent(false);

        if (premiumMwebInlineVideo) {
          const video = deferredMedia.querySelector('video');
          if (video) {
            video.controls = false;
            video.removeAttribute('controls');
            video.muted = true;
            video.playsInline = true;
            video.loop = true;
            video.setAttribute('playsinline', '');
            video.setAttribute('muted', '');
            video.play().catch(() => {});
          }
        }
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
